// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';
import { PersonRef } from './personRef.zod.ts';

export const ResearchSummaryOut = zod.object({
  "created_at": zod.iso.datetime({"offset":true}),
  "error": zod.union([zod.string(),zod.null()]),
  "finished_at": zod.union([zod.iso.datetime({"offset":true}),zod.null()]),
  "id": zod.uuid(),
  "model_key": zod.union([zod.string(),zod.null()]),
  "model_name": zod.union([zod.string(),zod.null()]).optional(),
  "prompt_version": zod.union([zod.string(),zod.null()]),
  "prompt_version_number": zod.union([zod.int(),zod.null()]),
  "refinement": zod.union([zod.string(),zod.null()]).optional(),
  "requested_by": zod.union([PersonRef,zod.null()]),
  "started_at": zod.union([zod.iso.datetime({"offset":true}),zod.null()]),
  "status": zod.enum(['queued', 'running', 'succeeded', 'failed']),
  "total": zod.union([zod.number(),zod.null()]),
  "verdict": zod.union([zod.enum(['go', 'conditional_go', 'no_go']),zod.null()])
});

export type ResearchSummaryOut = zod.input<typeof ResearchSummaryOut>;
export type ResearchSummaryOutOutput = zod.output<typeof ResearchSummaryOut>;
